import Pagination from './Pagination';
import { withInstall } from '../_util/type';
export { paginationProps, paginationConfig } from './Pagination';
export default withInstall(Pagination);
